import React, { useState, useEffect } from "react";
import PieChart from "../Common/PieChart";
import { formatNumber } from "../../utils/helper";
import { useSelector } from "react-redux";
import { getCurrency } from "../../utils/helper";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { mapDuration } from "../../utils/helper";

const chartColors = [
  "#ee8501",
  "#ffca39",
  "#FFCE56",
  "#4BC0C0",
  "#FF9F40",
  "#FF6384",
  "#36A2EB",
  "#4BC0C0",
  "#9966FF",
];

const options = ["1 Month", "3 Months", "6 Months", "1 Year", "All"];

const BuyBoxAnalysis = ({ data, settingsData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [graphData, setGraphData] = useState(data);
  const [selectedOption, setSelectedOption] = useState(() =>
      options.includes(settingsData?.defaultValues?.bb_analysis_timeframe)
        ? settingsData.defaultValues.bb_analysis_timeframe
        : "1 Month"
  );
  const [selectedData, setSelectedData] = useState(data?.days_30);
  const total_days = useSelector((state) => state.globalStates.total_days);

  useEffect(() => {
    const selectedData =
      selectedOption === "1 Month"
        ? data?.days_30
        : selectedOption === "3 Months"
        ? data?.days_90
        : selectedOption === "6 Months"
        ? data?.days_180
        : selectedOption === "1 Year"
        ? data?.days_365
        : data?.days_all;
    setSelectedData(selectedData);
    setGraphData(selectedData);
  }, [selectedOption, data]);

    useEffect(() => {
      if(settingsData?.defaultValues?.bb_analysis_timeframe){
        const defaultOption = options.includes(settingsData.defaultValues.bb_analysis_timeframe)
          ? settingsData.defaultValues.bb_analysis_timeframe
          : selectedOption;
        setSelectedOption(defaultOption);
      }
    }, [settingsData])

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        className="flex flex-col w-full text-white"
      >
        <div
          className="flex cursor-pointer items-center mb-4 justify-between"
          onClick={toggleAccordion}
        >
          <div
            className="mr-1 text-primary text-md font-bold"
          >
            Buy Box Analysis
          </div>
          <div className="text-primary">
            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
          </div>
        </div>
        {isOpen && (
          <>
            <div>
              <div className="flex items-center bg-secondary-bg rounded-md mb-2">
                {options.map((option, index) => (
                  <div
                    key={index}
                    className={`cursor-pointer w-full px-3 py-2 text-xs font-semibold rounded-md ${
                      selectedOption === option
                        ? "bg-primary text-secondary"
                        : "text-primary"
                    }`}
                    onClick={() => setSelectedOption(option)}
                  >
                    {mapDuration(option)}
                  </div>
                ))}
              </div>
              <div className="px-3 mb-2">
                {selectedData && selectedData.length > 0 && (
                  <div className="w-full flex items-center justify-center gap-4">
                    <div className="" style={{ width: "200px", height: "200px" }}>
                      <PieChart
                        data={selectedData}
                        valueProperty="percentageWon"
                      />
                    </div>
                    <div className="flex flex-col gap-2 mt-4">
                      {selectedData && selectedData.length > 0 && (
                        <>
                          {selectedData.slice(0, 9).map((item, index) => (
                            <div key={index} className="flex items-center">
                              <div
                                className="w-2 h-2 rounded-full border border-white flex-shrink-0"
                                style={{
                                  backgroundColor: chartColors[index],
                                }}
                              ></div>
                              <span
                                className="ml-2 text-white"
                                style={{ fontSize: "12px" }}
                              >
                                {item.sellerName}
                              </span>
                            </div>
                          ))}
                          {selectedData.length > 9 && (
                            <div className="text-left text-primary text-xs">
                              +{selectedData.length - 9} more
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="relative">
                <table
                  className="w-full mt-2 text-xs"
                >
                  <thead>
                    <tr className="font-semibold">
                      <div className="flex bg-secondary-bg rounded-lg py-1.5 mb-2 text-center">
                        <div className="p-1 flex-2"></div>
                        <div className="p-1 flex-1">Seller</div>
                        <div className="p-1 flex-1">Avg Price</div>
                        <div className="p-1 flex-1">Won</div>
                        <div className="p-1 flex-1 text-primary">Last Won</div>
                      </div>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedData?.map((property, index) => (
                      <tr key={index}>
                        <td className="p-0">
                          <div
                            className="text-center text-white bg-secondary-bg p-2 mb-1.5 rounded-lg"
                          >
                            <div className="flex items-center justify-around">
                              <div className="p-1 pl-0 pr-2 flex-2">
                                #{index + 1}
                              </div>{" "}
                              {/* Serial Number */}
                              <div
                                className="p-1 flex-1"
                                style={{
                                  // wrap text if it is too long
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {property?.sellerName || "-"}
                              </div>
                              <div
                                className="p-1 flex-1"
                                style={{
                                  // show ellipsis if the text is too long
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {getCurrency(settingsData?.marketplace) + formatNumber(property?.avgPrice / 100)}
                              </div>
                              <div
                                className="p-1 flex-1"
                                style={{
                                  // show ellipsis if the text is too long
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {property?.percentageWon.toFixed(2)}%
                              </div>
                              <div className="p-1 flex-1 text-primary">
                                {property?.lastSeen}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BuyBoxAnalysis;
